import { IOfferCard } from '../../../../types';

export const prepareMoreOffersLink = ({ offerUser, dealType, cianUserId, offerType, isTop3 }: IOfferCard) => {
  if (!isTop3) {
    return;
  }

  const userId = offerUser?.cianUserId || cianUserId || undefined;

  const userIdForLink = offerUser?.masterAgent?.id || userId;

  const userIdQuery = userIdForLink ? `id_user=${userIdForLink}&` : '';

  return `/cat.php?${userIdQuery}deal_type=${dealType}&${offerType}=yes&engine_version=2`;
};
